import gql from 'graphql-tag';

const processFinancingBackgroundChecks = gql`
  mutation processFinancingBackgroundChecks {
    processFinancingBackgroundChecks
  }
`;

const processFinancingNegotiations = gql`
  mutation processFinancingNegotiations {
    processFinancingNegotiations
  }
`;

const processFinancingCashOrders = gql`
  mutation processFinancingCashOrders {
    processFinancingCashOrders
  }
`;

const processFinancingBarterApplicants = gql`
  mutation processFinancingBarterApplicants($emailAddress: String) {
    processFinancingBarterApplicants(emailAddress: $emailAddress)
  }
`;

const financingSeedOrderActivePricing = gql`
  query {
    financingSeedOrderActivePricing {
      id
      bioPriceFull
      bioPriceDiscount
      interestRate
    }
  }
`;

const updateFinancingSeedOrderActivePricing = gql`
  mutation updateFinancingSeedOrderActivePricing($data: FinancingSeedOrderPricingStructureCreateInput!) {
    updateFinancingSeedOrderActivePricing(data: $data) {
      id
      bioPriceFull
      bioPriceDiscount
      interestRate
    }
  }
`;

const upsertFinancingUser = gql`
  mutation upsertFinancingUser($data: FinancingUserInput!) {
    upsertFinancingUser(data: $data) {
      id
    }
  }
`;

const deleteFinancingUser = gql`
  mutation deleteFinancingUser($id: ID!) {
    deleteFinancingUser(id: $id) {
      id
    }
  }
`;

const financingUsersQueryFields = `
  id
  email
  firstName
  lastName
  permissions
  role {
    id
    name
    description
  }
  preferences {
    id
    salesReps {
      id
      salesforceUserId
      name
    }  
  }  
`;

const financingUsersQuery = `
financingUsers {
  ${financingUsersQueryFields}
}
`;

const upsertSalesReps = gql`
  mutation upsertSalesReps($salesReps: [SalesRepsInput!]!, $creditAnalystUserId: String!) {
    upsertSalesReps(salesReps: $salesReps, creditAnalystUserId: $creditAnalystUserId) {
      ${financingUsersQueryFields}
    } 
  }
`;

const financingUsers = gql`
  query {
    ${financingUsersQuery}
  }
`;

const getAllCreditAnalysts = gql`
  query getAllCreditAnalysts {
    getAllCreditAnalysts {
      id
      firstName
      lastName
    }
  }
`;

const getAllSalesReps = gql`
  query getAllSalesReps {
    getAllSalesReps {
      id
      salesforceUserId
      name
    }
  }
`;

const rolesAndUsers = gql`
  query {
    allAssignableFinancingRoles {
      id
      name
      description
      scope
    }
    ${financingUsersQuery}
    financingCurrentUser {
      id
      email
    }
    financingOrganizations(limit: 10, offset: 0) {
      organizations {
        id
        name
      }
    }
  }
`;

const allConversationAvailableBrRoles = gql`
  query {
    allConversationAvailableBrRoles {
      id
      name
      description
      scope
    }
  }
`;

const triggerPoll = gql`
  mutation triggerPoll($pollToTrigger: AgFinancingPolls!) {
    triggerPoll(pollToTrigger: $pollToTrigger)
  }
`;

const allCampaigns = gql`
  query {
    financingCampaigns {
      id
      name
      isActive
      isExternal
      salesforceId
    }
  }
`;

const toggleAgCampaignActive = gql`
  mutation toggleAgCampaignActive($campaignId: Int!) {
    toggleAgCampaignActive(campaignId: $campaignId) {
      id
      isActive
    }
  }
`;

const addNewCampaign = gql`
  mutation addAgCampaign($newCampaignInfo: AgNewCampaignInput!) {
    addAgCampaign(newCampaignInfo: $newCampaignInfo) {
      id
      name
      isActive
      isExternal
      salesforceId
    }
  }
`;

const inviteNewUser = gql`
  mutation inviteNewUser(
    $email: String!
    $givenName: String!
    $familyName: String!
    $organizationId: String!
    $role: String!
  ) {
    inviteNewUser(
      email: $email
      givenName: $givenName
      familyName: $familyName
      organizationId: $organizationId
      role: $role
    ) {
      id
      email
      role {
        name
      }
    }
  }
`;

export {
  addNewCampaign,
  allCampaigns,
  allConversationAvailableBrRoles,
  deleteFinancingUser,
  financingSeedOrderActivePricing,
  financingUsers,
  getAllCreditAnalysts,
  getAllSalesReps,
  inviteNewUser,
  processFinancingBackgroundChecks,
  processFinancingBarterApplicants,
  processFinancingCashOrders,
  processFinancingNegotiations,
  rolesAndUsers,
  toggleAgCampaignActive,
  triggerPoll,
  updateFinancingSeedOrderActivePricing,
  upsertFinancingUser,
  upsertSalesReps
};
